export const SITE_NAME = 'AllChinaBuy Spreadsheet';

export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://allchinabuyspread.guru').replace(/\/+$/, '');

export const LOGO_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png';

export const DEFAULT_KEYWORDS =
  'AllChinaBuy, spreadsheet, buying guide, product resources, sellers, QC, shipping, coupon, review, warehouse';